/* Publish by EComposer at 2026-10-23 10:58:06*/
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-yfiq7wtv8oa"]=  window.__ectimmers["ecom-yfiq7wtv8oa"] || {};
if(!this.$el)return;const t=this.$el,e=t.querySelector(".ecom-text_view-more-btn"),i=t.querySelector(".ecom-text_view-less-btn"),s=t.querySelector(".text-content.ecom-html");!s||(e&&e.addEventListener("click",()=>{s.classList.remove("ecom-text--is-mark"),s.style.maxHeight="",e.style.display="none",i.style.display=""}),i&&i.addEventListener("click",()=>{s.classList.add("ecom-text--is-mark"),s.style.maxHeight="var(--ecom-text-height)",i.style.display="none",e.style.display=""}))

                    });
                    
                        document.querySelectorAll('.ecom-yfiq7wtv8oa').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-yfiq7wtv8oa', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-4f1yk8fffev').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-4f1yk8fffev', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ljr78yd59ak').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ljr78yd59ak', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-etplz0il4mv').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-etplz0il4mv', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-mr338cxzmna').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-mr338cxzmna', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-g8olg8zf6o7').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-g8olg8zf6o7', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-k9fhp2ft0r').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-k9fhp2ft0r', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-kejpqpoit8s').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-kejpqpoit8s', settings: {},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-ahj0kxyhwa"]=  window.__ectimmers["ecom-ahj0kxyhwa"] || {};
if(!this.$el)return!1;const t=this.$el;this.settings.animation&&function(i){if(!t)return;const s=t.querySelector(".ecom__element--button");if(!s)return;let o=parseInt(i.settings.animation_loop_time)*1e3||6e3,n=1e3;window.__ectimmers["ecom-ahj0kxyhwa"]["bxb9yjvik"] = setInterval(function(){s.classList.add("animated"),setTimeout(function(){s.classList.remove("animated")},n)},o)}(this);var e=t.querySelector(".ecom__element--button");this.isLive&&e&&e.dataset.ecTrackingId&&e.addEventListener("click",function(i){if(window.Shopify&&window.Shopify.analytics){i.preventDefault();let s=window.EComposer.PAGE||window.EComposer.TEMPLATE||window.EComposer.SECTION||window.EComposer.BLOCK||{};const o=Object.assign({button_id:e.id,tracking_id:e.dataset.ecTrackingId},s);try{Shopify.analytics.publish("ec_custom_events",o)}catch(a){console.error("[EC Tracking] Error publishing analytics event:",a)}const n=e.getAttribute("href"),r=e.getAttribute("target");n&&n!=="#"&&n!=="javascript:void(0)"&&(r==="_blank"?window.open(n,"_blank"):setTimeout(function(){window.location.href=n},300))}},{once:!0}),this.isLive&&e&&e.dataset.eventTrackingFb&&e.addEventListener("click",function(i){window.fbq&&window.fbq("track",`${e.dataset.eventTrackingFb}`)},{once:!0})

                    });
                    
                        document.querySelectorAll('.ecom-ahj0kxyhwa').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ahj0kxyhwa', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-5ilvv9exby').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-5ilvv9exby', settings: {"animation":false},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-e00ezdsbt7m"]=  window.__ectimmers["ecom-e00ezdsbt7m"] || {};
const t=function(r){if(window.EComModal)return r();if(window.EComposer&&typeof window.EComposer.loadVendor=="function"){window.EComposer.loadVendor("modal_js").then(function(){window.EComModal&&r()});return}let a=0;const l= window.__ectimmers["ecom-e00ezdsbt7m"]["plqnwzbdo"] = setInterval(function(){window.EComModal?(clearInterval(l),r()):++a>=300&&clearInterval(l)},50)};if(this.settings.link==="lightbox"&&this.settings.lightbox==="yes"&&this.$el){var e=this.$el.querySelector("[ecom-modal]"),i=this.id;t(function(){new window.EComModal(e,{cssClass:["ecom-container-lightbox-"+i]})})}let s=this.$el;if(!s)return;function o(r){const a=r.getBoundingClientRect();return a.top>=0&&a.left>=0&&a.bottom-r.offsetHeight/2<=(window.innerHeight||document.documentElement.clientHeight)&&a.right<=(window.innerWidth||document.documentElement.clientWidth)}function n(){let r=s.querySelector(".ecom-element.ecom-base-image"),a=s.closest(".core__row--columns");r&&(o(r)?(r.classList.add("image-highlight"),a.setAttribute("style","z-index: unset")):(r.classList.remove("image-highlight"),a.setAttribute("style","z-index: 1")))}this.settings.highligh_on_viewport&&window.addEventListener("scroll",function(){n()})

                    });
                    
                        document.querySelectorAll('.ecom-e00ezdsbt7m').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-e00ezdsbt7m', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-dzt15a3gpxt').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-dzt15a3gpxt', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ybqrlbbpo1a').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ybqrlbbpo1a', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-uddnj45b6wn').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-uddnj45b6wn', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-dgtkz7xrqqd').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-dgtkz7xrqqd', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-13ys79ibcm7').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-13ys79ibcm7', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-a36i75yc1cf').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-a36i75yc1cf', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-pfx25r36ji').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-pfx25r36ji', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-mbghpvm7i').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-mbghpvm7i', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-lr93ui1pe2').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-lr93ui1pe2', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-a48jyry08k').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-a48jyry08k', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-rndhcivxgk').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-rndhcivxgk', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-3aie52rbvrk').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-3aie52rbvrk', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-qgyd4wc9ap').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-qgyd4wc9ap', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    

                })();
            
;try{
 
} catch(error){console.error(error);}